import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function SupplierLayout({ children, user }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
      navigate('/login');
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="min-h-screen bg-[#F0F2EB]">
      {/* Simple Header - No Navigation */}
      <header className="bg-white border-b border-[#1A4331]/10">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#6B9F4A] to-[#1A4331] flex items-center justify-center">
                <span className="text-white font-bold text-lg">H</span>
              </div>
              <div>
                <h1 className="text-xl font-bold text-[#1A4331]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  Homegrown
                </h1>
                <p className="text-xs text-[#8EAA97]">Supplier Portal</p>
              </div>
            </div>

            {/* User Info + Logout */}
            <div className="flex items-center gap-4">
              <div className="text-right">
                <p className="text-sm font-semibold text-[#1A4331]">{user?.name || 'Supplier'}</p>
                <p className="text-xs text-[#8EAA97]">{user?.email}</p>
              </div>
              <button
                onClick={handleLogout}
                className="p-2 hover:bg-[#F0F2EB] rounded-full transition-colors"
                title="Logout"
              >
                <LogOut className="w-5 h-5 text-[#5C665C]" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content - Full Width, No Sidebar */}
      <main className="max-w-7xl mx-auto px-6 py-8">
        {children}
      </main>

      {/* Simple Footer */}
      <footer className="bg-white border-t border-[#1A4331]/10 mt-12">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex items-center justify-between text-sm text-[#8EAA97]">
            <p>© 2025 Homegrown. Supplier Portal.</p>
            <p>
              Questions? Contact:{' '}
              <a href="mailto:suppliers@homegrownapp.kiwi" className="text-[#1A4331] hover:underline">
                suppliers@homegrownapp.kiwi
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default SupplierLayout;
